import { SC } from "helper/ServerCall";
import { pathSegment } from "helper/queryString";

export const itemService = {
    getItems,
    getItemsByCategory,
    createOrderAssignedItemsWithType,
    getItemPagination,
    storeItem,
    editItem,
    updateItem,
    deleteItem,
    getItemsByTypeByLoction,
    unassignOrderShippingItem,
    getReorderEntryItems
}

function getItems(type) {
    if (type) {
        return SC.getCall(`getItemsByType/${pathSegment(type)}`);
    }
    return SC.getCall('getItemsByType');
}

function getItemsByCategory(cat) {
    return SC.getCall(`getItemsByCategory/${pathSegment(cat)}`);
}

function createOrderAssignedItemsWithType(data, type, shippingItemId) {
    return SC.postCall(`createOrderAssignedItemsWithTypeWithBarcode/${pathSegment(shippingItemId)}/${pathSegment(type)}`, data);
}

function getItemPagination(page, filter, sort, pageSize) {
    return SC.getCall('item', { page, filter, sort, pageSize });
}
function storeItem(ItemData) {
    return SC.postCall('items', ItemData);
}
function editItem(itemId) {
    return SC.getCall(`items/${pathSegment(itemId)}`);
}
function updateItem(data, id) {
    return SC.putCall(`items/${pathSegment(id)}`, data);
}
function deleteItem(ItemId) {
    return SC.deleteCall(`items/${pathSegment(ItemId)}`);
}
function getItemsByTypeByLoction(type, location) {
    return SC.getCall(`getItemsByTypeByLoction/${pathSegment(type)}/${pathSegment(location)}`);
}
function unassignOrderShippingItem(orderShippingId, type) {
    return SC.deleteCall(`deleteOrderAssignedItem/${pathSegment(orderShippingId)}/${pathSegment(type)}`);
}

function getReorderEntryItems() {
    return SC.getCall('getReorderEntryItems');
}
